import { stringCompareAscend } from "flow/localization/stringCompare";
import { Theme } from "../entities/Theme";

let availableThemes: Theme[] = [];

function set(themes: Theme[]) {
    availableThemes = themes.slice().sort((a, b) => stringCompareAscend(a.name, b.name));
}

function get() {
    return availableThemes;
}

export default {
    set: set,
    get: get
};
